import { render, staticRenderFns } from "./IpsLink.vue?vue&type=template&id=6de2127e"
import script from "./IpsLink.vue?vue&type=script&lang=js"
export * from "./IpsLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports